"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "elice": {
    "2ff1df20": [{
      "hkey": "d336b316",
      "slug": "elice",
      "name": "Elice",
      "primary": true,
      "skipSearch": false
    }],
    "case-chiavarini": [{
      "hkey": "d336b316",
      "slug": "elice",
      "name": "Elice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90a6ccc4": [{
      "hkey": "df1e1c5c",
      "slug": "bastioni",
      "name": "Bastioni",
      "primary": true,
      "skipSearch": false
    }],
    "cocciagrasso": [{
      "hkey": "df1e1c5c",
      "slug": "bastioni",
      "name": "Bastioni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eef7d8e2": [{
      "hkey": "1c544011",
      "slug": "madonna-degli-angeli",
      "name": "Madonna degli Angeli",
      "primary": true,
      "skipSearch": false
    }],
    "collina-madonna-degli-angeli": [{
      "hkey": "1c544011",
      "slug": "madonna-degli-angeli",
      "name": "Madonna degli Angeli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;